module.exports = __webpack_public_path__ + "assets/images/stereo-04.27c85b1f73f7efa10031e728ebef5045.svg";